/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { ReduxUtils } from '@spm/core';
import models from './models';

/**
 * Gets NewACESBurialHomeDetailsListResponse from api:
 * /v1/ua/aces_chap_burial_provider_search
 *
 * @param {any} callback function to call once this function has finished
 */
const fetchAcesChapBurialProviderSearchUtil = callback => {
  ReduxUtils.getModelDataFromRestAPI(
    callback,
    `v1/ua/aces_chap_burial_provider_search`,
    models.NewACESBurialHomeDetailsListResponse
  );
};

/**
 * Gets NewACESInsuranceProviderDetailsListResponse from api:
 * /v1/ua/aces_chap_insurance_provider_search
 *
 * @param {any} callback function to call once this function has finished
 */
const fetchAcesChapInsuranceProviderSearchUtil = callback => {
  ReduxUtils.getModelDataFromRestAPI(
    callback,
    `v1/ua/aces_chap_insurance_provider_search`,
    models.NewACESInsuranceProviderDetailsListResponse
  );
};

export { fetchAcesChapBurialProviderSearchUtil, fetchAcesChapInsuranceProviderSearchUtil };
